import React, { Component } from "react";
// import "../Header/Header.css";
// import "./MainOuter.css";
import { Route } from "react-router-dom";

import Fader from 'react-fader';
import Switch from 'react-router-transition-switch'

import * as Constants from "../../../constants/Constants";

import * as AppUrls from "../../../constants/AppUrls";

import QRScanner from "../ScanReader/QRScanner";
import UserConfirms from "../UserConfirms/UserConfirms";
import OnboardingProfileConfirm from "../OnboardingProfileConfirm/OnboardingProfileConfirm";
import OnboardingMain from "../OnboardingMain/OnboardingMain";
import ScanPassportAuthentication from "../OnboardingNonSIBAccount/ScanPassportAuthentication";
import SignatureForm from "../OnboardingNonSIBAccount/SignatureForm";
import AccountSelector from "../OnboardingCustomerInformation/AccountSelector";

class MainOuterOnboarding extends React.PureComponent {

    render() {

        return (
            <div >

                <Switch component={Fader}>

                    <Route
                        exact
                        path={AppUrls.onboardingPersonal}
                        render={() =>
                            <QRScanner
                                theme={this.props.theme}
                            />
                        }
                    />
                    <Route
                        exact
                        path={AppUrls.onboardingUserConfirms}
                        render={() =>
                            <UserConfirms
                                theme={this.props.theme}
                            />
                        }
                    />
                    <Route
                        exact
                        path={AppUrls.onboardingProfileConfirms}
                        render={() =>
                            <OnboardingProfileConfirm
                                theme={this.props.theme}
                            />
                        }
                    />
                    <Route
                        exact
                        path={AppUrls.OnboardingNonSIBAccount}
                        render={() =>
                            <ScanPassportAuthentication
                                theme={this.props.theme}
                            />
                        }
                    />
                    <Route
                        exact
                        path={AppUrls.AccountSelector}
                        render={() =>
                            <AccountSelector
                                theme={this.props.theme}
                            />
                        }
                    />
                    <Route
                        exact
                        path={AppUrls.OnboardingNonSIBAccountSignature}
                        render={() =>
                            <SignatureForm
                                theme={this.props.theme}
                            />
                        }
                    />
                    <Route
                        exact
                        path={AppUrls.onboardingMain}
                        render={() =>
                            <OnboardingMain
                                theme={this.props.theme}
                            />
                        }
                    />
                </Switch>
            </div>
        );
    }
}

export default MainOuterOnboarding;
